module.exports = __webpack_public_path__ + "static/media/features-split-image-03.2f5a2add.png";